define(["jquery", "@modules/utils", "velocity"], function ($, utils) {
    function initHelpOptionsMenu() {
        // console.log('init navigation');

        var $mainContainer = $(".how-can-we-help-container");
        var $triggerContainer = $(".help-block-categories");
        var $trigger = $(".help-block-categories .has-menu"); // only items with class .has-menu will trigger
        var $menuContainer = $(".help-block-group-container");
        var $menu = $(".help-block-group-container .slide-menu");
        var $close = $(".help-block-group-container .close-menu");

        var triggerContainerHeight = $triggerContainer.height();
        $mainContainer.css({ height: triggerContainerHeight });
        $mainContainer.removeClass("no-js");

        // close mobile or desktop menus depending on viewport
        $(window).resize(
            utils.debounce(function () {
                var triggerContainerHeight = $triggerContainer.height();
                var menuContainerHeight = $menuContainer.height();
                if ($menu.hasClass("menu-open")) {
                    $mainContainer.css({ height: menuContainerHeight });
                } else {
                    $mainContainer.css({ height: triggerContainerHeight });
                }
            }, 250)
        );

        // close menu function
        function closeNavMenu() {
            $triggerContainer
                .velocity({
                    translateX: 0
                })
                .attr("aria-hidden", "false");
            $menuContainer
                .velocity(
                    {
                        left: "-100%"
                    },
                    {
                        complete: function () {
                            $menu.hide();
                            $menu.removeClass("menu-open");
                            $menu.attr("aria-expanded", "false"); // accessibility
                            $menu.attr("tabindex", ""); // accessibility
                            $trigger.each(function () {
                                if ($(this).is(".active")) {
                                    $(this).focus();
                                }
                            });
                            $trigger.removeClass("active");
                            // $trigger.find('> a').attr('aria-expanded', 'false'); // accessibility
                            var triggerContainerHeight = $triggerContainer.height();
                            $mainContainer.css({ height: triggerContainerHeight });
                        }
                    }
                )
                .attr("aria-hidden", "true");
        }

        if ($trigger.length > 0) {
            $trigger.on("click", function (e) {
                var $this = $(this);
                var target = $this.attr("data-bs-target");
                // check if t1 menu is currently animating - prevent clicks
                if ($trigger.is(".animating")) {
                    event.stopPropagation();
                }
                // open targeted menu
                else {
                    $this.addClass("animating");

                    $triggerContainer.velocity({ translateX: "100%" });
                    $triggerContainer.attr("aria-hidden", "true");
                    $menuContainer
                        .velocity(
                            {
                                left: 0
                            },
                            {
                                begin: function () {
                                    // console.log("begin");
                                    $(target).show(function () {
                                        $(target).addClass("menu-open");
                                        $(target).attr("aria-expanded", "true"); // accessibility
                                        $(target).find("a").first().focus(); // accessibility
                                        $trigger.removeClass("animating");
                                        var menuContainerHeight = $menuContainer.height();
                                        $mainContainer.css({ height: menuContainerHeight });
                                    });
                                }
                            }
                        );
                    $menuContainer.attr("aria-hidden", "false");

                    //trap tabbing
                    var tabbable = $(target).find("a");
                    var firstTabbable = tabbable.first();
                    var lastTabbable = tabbable.last();
                    /*redirect last tab to first input*/
                    lastTabbable.on("keydown", function (e) {
                        if (e.which === 9 && !e.shiftKey) {
                            e.preventDefault();
                            firstTabbable.focus();
                        }
                    });
                    /*redirect first shift+tab to last input*/
                    firstTabbable.on("keydown", function (e) {
                        if (e.which === 9 && e.shiftKey) {
                            e.preventDefault();
                            lastTabbable.focus();
                        }
                    });

                    $this.addClass("active");
                    // $this.find('> a').attr('aria-expanded', 'true'); // accessibility

                    // Add ESC key functionality to close visible menu
                    $(document).keyup(function (e) {
                        if (e.keyCode === 27) {
                            closeNavMenu();
                        }
                        e.preventDefault();
                    });
                }
                e.preventDefault();
            });
            // close menu
            $close.on("click", function (e) {
                closeNavMenu();
                e.preventDefault();
            });
        }
    }

    initHelpOptionsMenu();
});
